import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';

class PackageServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getDisplayedList(params = {}) {
    return this.pure_http.get('pbx/client/service-packages/displayed', {
      params: {
        sort_direction: 'asc',
        sort_column: 'weight',
        ...params
      }
    });
  }
}

export const PackageService = new PackageServiceClass({
  api_version: 2,
  resource: 'pbx/service-packages'
});
